import GameStrip from './GameStrip'
import GameHeader from './GameHeader'
import GlobalNavTertiary from './GlobalNavTertiary'
import PlayersToWatch from './PlayersToWatch'
import PlayerDetails from './PlayerDetails'
import HeadToHead from './HeadToHead'
import VideoGrid from './VideoGrid'
import composeView from './composeView'

export { GameStrip }
export { GameHeader }
export { GlobalNavTertiary }
export { PlayersToWatch }
export { PlayerDetails }
export { HeadToHead }
export { VideoGrid }
export { composeView }

export default{
  GameStrip,
  GameHeader,
  GlobalNavTertiary,
  PlayersToWatch,
  PlayerDetails,
  HeadToHead,
  VideoGrid,
  composeView
}



// WEBPACK FOOTER //
// ../app/components/gamepackage/index.js